import { render, staticRenderFns } from "./MyLeadsV2.vue?vue&type=template&id=3bf2128c&"
import script from "./MyLeadsV2.vue?vue&type=script&lang=js&"
export * from "./MyLeadsV2.vue?vue&type=script&lang=js&"
import style0 from "./MyLeadsV2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports